import React from 'react';
import axios from 'axios';
import { format, /*parseISO*/ } from 'date-fns';

const getType = (clickType) => {
    switch(clickType) {
        case 'asbestos':
            return 'asbestos';
        case 'special':
            return 'special';
        case 'dock':
            return 'dock';
        // case 'red':
        //     return 'checkRed';
        case 'check':
        case 'normal':
        default:
            return 'check';
    }
};

// const getType = (clickType) => {
//     switch(clickType) {
//         case 'red':
//             return 'checkRed';
//         case 'check':
//         case 'normal':
//         default:
//             return 'check';
//     }
// };

// return new Promise((resolve, reject) => {
//     resolve();
// });

export const useAjax = () => {
    const getEventHist = React.useCallback((date) => {
        return axios.get(`/api/eventHist/${format(date, 'yyyy-MM-dd')}`);
    }, []);
    const getCheckHist = React.useCallback((date, waku) => {
        return axios.get(`/api/checkHist/${format(date, 'yyyy-MM-dd')}/${waku}`);
    }, []);

    const getEvents = React.useCallback((date) => {
        return axios.get(`/api/events/${format(date, 'yyyy-MM-dd')}`);
    }, []);

    const updateHoliday = React.useCallback((date, isEffective, authState) => {
        if(isEffective) {
            return axios.put(`/api/events/${format(date, 'yyyy-MM-dd')}/holiday`, {name: authState.name});
        } else {
            return axios.delete(`/api/events/${format(date, 'yyyy-MM-dd')}/holiday`, {data: {name: authState.name}});
        }
    }, []);
    const updateEmerge = React.useCallback((date, isEffective, authState) => {
        if(isEffective) {
            return axios.put(`/api/events/${format(date, 'yyyy-MM-dd')}/emerge`, {name: authState.name});
        } else {
            return axios.delete(`/api/events/${format(date, 'yyyy-MM-dd')}/emerge`, {data: {name: authState.name}});
        }
    }, []);
    const updateMemo = React.useCallback((date, memo, authState) => {
        return axios.put(`/api/memo/${format(date, 'yyyy-MM-dd')}`, {memo, name: authState.name});
    }, []);

    
    const getChecks = React.useCallback((date) => {
        return axios.get(`/api/checks/${format(date, 'yyyy-MM-dd')}`);
    }, []);

    const wakuClose = React.useCallback((date, waku, authState)=>{
        return axios.put(`/api/checks/${format(date, 'yyyy-MM-dd')}/${waku}/close`, {name: authState.name})
    }, []);
    const wakuOpen = React.useCallback((date, waku, authState)=>{
        return axios.delete(`/api/checks/${format(date, 'yyyy-MM-dd')}/${waku}/close`, {data: {name: authState.name}})
    }, []);

    // const wakuCheck = React.useCallback((date, waku, clickType)=>{
    //     return axios.put(`/api/checks/${format(date, 'yyyy-MM-dd')}/${waku}/${getType(clickType)}`)
    // }, []);
    // const wakuCheck = React.useCallback((date, waku, clickType, memo)=>{
    //     return axios.put(`/api/checks/${format(date, 'yyyy-MM-dd')}/${waku}/${getType(clickType)}`, {memo})
    // }, []);
    const wakuCheck = React.useCallback((date, waku, clickType, clickColor, memo, authState)=>{
        return axios.put(`/api/checks/${format(date, 'yyyy-MM-dd')}/${waku}/${getType(clickType)}/${clickColor}`, {memo, name: authState.name})
    }, []);
    const wakuUncheck = React.useCallback((date, waku, clickType, authState)=>{
        return axios.delete(`/api/checks/${format(date, 'yyyy-MM-dd')}/${waku}/${getType(clickType)}`, {data: {name: authState.name}})
    }, []);


    return {
        getEvents, getChecks,
        wakuOpen, wakuClose,
        wakuCheck, wakuUncheck,
        updateHoliday, updateEmerge, updateMemo,
        getEventHist, getCheckHist,
    }
}

export const useAuthAjax = () => {
    const login = React.useCallback((scode, spass) => {
        return axios.post(`/api/auth/login`, {scode, spass});
    }, []);

    const chPasswd = React.useCallback((id, scode, sname, spass) => {
        return axios.put(`/api/auth/password/${id}`, {id, scode, sname, spass});
    }, []);
    

    return {
        login, chPasswd
    }
}

export const useStaffsAjax = () => {
    const getStaffs = React.useCallback(() => {
        return axios.get(`/api/master/staffs`, {});
    }, []);

    const staffEnable = React.useCallback((scode) => {
        return axios.put(`/api/master/staff/enable/${scode}`, {});
    }, []);

    const staffDisable = React.useCallback((scode) => {
        return axios.delete(`/api/master/staff/enable/${scode}`, {});
    }, []);

    const resetPassword = React.useCallback((scode) => {
        return axios.delete(`/api/master/staff/password/${scode}`, {});
    }, []);

    const createStaff = React.useCallback((staff) => {
        return axios.post(`/api/master/staff`, staff);
    }, []);

    const modifyStaff = React.useCallback((staff) => {
        return axios.put(`/api/master/staff/${staff.id}`, staff);
    }, []);

    return {
        getStaffs, staffEnable, staffDisable, resetPassword, createStaff, modifyStaff
    }
}
